import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { Language } from '../../types/Coach/ParticipantDetails';
export interface ReactConfig {
  applicationInsightsConnectionString: string;
}

export const languagesApi = createApi({
  reducerPath: 'languagesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${cmsApiConfig.url}/portalapi/languages`,
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  tagTypes: ['Languages'],
  endpoints: (builder) => ({
    getLanguages: builder.query<Language[], void>({
      query: () => ({
        url: '/',
        method: 'GET',
      }),
      providesTags: ['Languages'],
    }),
  }),
});

export const { useGetLanguagesQuery, useLazyGetLanguagesQuery } = languagesApi;
